/* eslint-disable indent */
/* eslint-disable no-restricted-imports */
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { getTasks } from "@/v2/service/tasksService";

import { IS_DEVELOPMENT } from "../../../v1/utils/constants";
import { useTaskManagerStore, WidgetState } from "../../store/useTaskManagerStore";

export const getParams = () => {
  const day = 24 * 60 * 60 * 1000;
  const now = new Date();
  const yesterday = new Date(new Date().getTime() - (IS_DEVELOPMENT ? 5 * 60 * 1000 : day));
  const query = `createdAtFrom=${yesterday.toISOString()}&createdAtTo=${now.toISOString()}&sort=created_at,desc`;

  const isEnabled = (widgetState: WidgetState) => {
    return widgetState !== WidgetState.hidden;
  };

  return {
    day,
    now,
    yesterday,
    query,
    isEnabled,
  };
};

export const useTasksQueryByLastDay = () => {
  const { widgetState, taskList, setWidgetState } = useTaskManagerStore();
  const { now, yesterday, query, isEnabled } = getParams();
  const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prevCount) => prevCount + 1);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return useQuery(["tasks-query-widget", taskList, now, yesterday, count], () => getTasks(query), {
    select: ({ data }) => data.results,
    enabled: isEnabled(widgetState),
    keepPreviousData: true,
    onError: () => setWidgetState(WidgetState.hidden),
  });
};
